export default "__VITE_ASSET__DRQkxf64__"